import constants from '../../constants';

export default {
  methods: {
    getTimePairClockingType(timePair) {
      if (timePair.isCorrection) {
        return constants.TimePairType.CORRECTION;
      }
      if (timePair.isManualPair) {
        return constants.TimePairType.MANUAL;
      }
      return constants.TimePairType.CLOCK;
    },
  },
};
